import { LoadingSpinner } from '../util/spinner/loading-spinner'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useLegalTermsAndConditions } from 'src/hook/use-legal'

export const TermsAndConditions = (): React.ReactElement => {
  const { data: termsAndConditions, isLoading } = useLegalTermsAndConditions()

  return (
    <LoadingSpinner isLoading={isLoading || !termsAndConditions}>
      {termsAndConditions && (
        <ReactMarkdown
          className={'markdown-table'}
          remarkPlugins={[remarkGfm]}
          transformLinkUri={(src: string): string => {
            if (src[0] === '#') return window.location.pathname + src
            return src
          }}
        >
          {termsAndConditions}
        </ReactMarkdown>
      )}
    </LoadingSpinner>
  )
}
